import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Card, Col, Container, Row, Tabs, Tab, Table } from "react-bootstrap";
import { FetchStatus } from "src/Utils/getAppointmentStatus";
const DoctorDetails = () => {
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col xs={12}>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="text-info">
              <FontAwesomeIcon
                icon={faArrowLeft}
                onClick={() => {
                  navigate(-1);
                }}
                className="mx-2 cursor"
              />
              DOCTOR DETAILS
            </h4>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Card className="rounded-lg border-0 shadow">
            <Row className="g-0">
              <Col xs={12} md={8} lg={9}>
                <Card.Body>
                  <Tabs
                    defaultActiveKey="personalDetails"
                    id="patient-details-tabs"
                    className="mb-3"
                  >
                    <Tab eventKey="personalDetails" title="Personal Info">
                      <dl className="row">
                        <dt className="col-sm-4 col-lg-3 text-muted">Name:</dt>
                        <dd className="col-sm-8 col-lg-9">{state.Name}</dd>

                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Date Of Birth:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.DateOfBirth}
                        </dd>

                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Address:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">{state.Address}</dd>

                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Phone Number:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.PhoneNumber}
                        </dd>

                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Gender:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">{state.Gender}</dd>

                        <dt className="col-sm-4 col-lg-3 text-muted">Email:</dt>
                        <dd className="col-sm-8 col-lg-9">{state.Email}</dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Medical School Attended:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {
                            state.ProfessionalInformation
                              .Medical_School_Attended
                          }
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Degree:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.ProfessionalInformation.Degree}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Specializations:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          <dd className="col-sm-8 col-lg-9">
                            {state.ProfessionalInformation.Specializations.join(
                              ", "
                            )}
                          </dd>
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Work Experience:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.ProfessionalInformation.work_experience} years
                          of experience
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Medical License Number:
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.LicensingInformation.Medical_License_Number}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Issuing State :
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.LicensingInformation.Issuing_State}
                        </dd>

                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Issuing Country :
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.LicensingInformation.Issuing_Country}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Date Of Issue :
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.LicensingInformation.dt_of_issue}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Languages Can Speak :
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.languages_can_speak.join(", ")}
                        </dd>
                        <dt className="col-sm-4 col-lg-3 text-muted">
                          Description :
                        </dt>
                        <dd className="col-sm-8 col-lg-9">
                          {state.Description}
                        </dd>
                      </dl>
                    </Tab>
                    <Tab eventKey="appointments" title="Appointments">
                      {state.Appointments.length > 0 ? (
                        <Table responsive bordered22 hover>
                          <thead>
                            <tr>
                              <th>Patient Name</th>
                              <th>Appointment Fees</th>
                              <th>Appointment Type</th>
                              <th>Appointment Date</th>
                              <th>Appointment Time </th>
                              <th>Status</th>
                            </tr>
                          </thead>

                          <tbody>
                            {state.Appointments?.map((itx, index) => (
                              <tr key={index}>
                                <td>{itx.patient_name}</td>
                                <td>{itx.appointment_fees}</td>
                                <td>{itx.appointment_type}</td>
                                <td>{itx.appointment_date}</td>
                                <td>{itx.appointment_time}</td>
                                <td
                                  className={
                                    FetchStatus(
                                      itx.appointment_date,
                                      itx.appointment_time
                                    ) == "upcoming"
                                      ? "upcoming-status-txt"
                                      : FetchStatus(
                                          itx.appointment_date,
                                          itx.appointment_time
                                        ) == "ongoing"
                                      ? "ongoing-status-txt"
                                      : "past-status-txt"
                                  }
                                >
                                  {FetchStatus(
                                    itx.appointment_date,
                                    itx.appointment_time
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      ) : (
                        <p className="text-center"> No Appointments Found !</p>
                      )}
                    </Tab>
                  </Tabs>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DoctorDetails;
